module.exports = __webpack_public_path__ + "img/5.d5cd0bf4.jpg";